import { get } from 'js-cookie';
import { format } from 'prettier';
import { string, number } from 'yup';

export interface IShopifyPricingProps {
    prices: number[];
    limites: number[];
    values: string[];

    initSelected?: number;

    price1Label: HTMLElement;
    price2Label: HTMLElement;
    price3Label: HTMLElement;

    limit1Label: HTMLElement;
    limit2Label: HTMLElement;
    limit3Label: HTMLElement;

    price1Base: number;
    price2Base: number;
    price3Base: number;

    limit1BaseText: string;
    limit2BaseText: string;
    limit3BaseText: string;
    limitLabel: string;

    format?: (value: number) => string;
    dev: boolean;
}

export default class ShopifyPricing {
    protected price1Base: number;
    protected price2Base: number;
    protected price3Base: number;
    protected limit1BaseText: string;
    protected limit2BaseText: string;
    protected limit3BaseText: string;
    protected price1Label: HTMLElement;
    protected price2Label: HTMLElement;
    protected price3Label: HTMLElement;
    protected limit1Label: HTMLElement;
    protected limit2Label: HTMLElement;
    protected limit3Label: HTMLElement;
    protected limitLabel: string;
    protected values: string[];

    private selected: number;
    private prices: number[];
    private limites: number[];
    private customFormat;
    private dev = false;

    constructor({
        prices,
        limites,
        initSelected = 0,
        price1Label,
        price2Label,
        price3Label,
        limit1Label,
        limit2Label,
        limit3Label,
        price1Base,
        price2Base,
        price3Base,
        limit1BaseText,
        limit2BaseText,
        limit3BaseText,
        limitLabel,
        values,
        format,
        dev = false,
    }: IShopifyPricingProps) {
        this.price1Base = price1Base;
        this.price2Base = price2Base;
        this.price3Base = price3Base;
        this.customFormat = format;
        this.dev = dev;
        this.values = values;

        this.limit1BaseText = limit1BaseText;
        this.limit2BaseText = limit2BaseText;
        this.limit3BaseText = limit3BaseText;

        this.price1Label = price1Label;
        this.price2Label = price2Label;
        this.price3Label = price3Label;

        this.limit1Label = limit1Label;
        this.limit2Label = limit2Label;
        this.limit3Label = limit3Label;

        this.limitLabel = limitLabel;

        this.prices = prices;
        this.limites = limites;
        this.selected = initSelected;

        this.onChange = this.onChange.bind(this);

        this.calculate();
    }

    private convertLimit = (limitText: string, valueToadd: number) => {
        const limitRegex = /(\d+)-(\d+)/;
        const match = limitText.match(limitRegex);

        if (match) {
            const lowerLimit = parseInt(match[1]);
            const upperLimit = parseInt(match[2]);

            const updatedLimit = `${lowerLimit + valueToadd}-${
                upperLimit + valueToadd
            }`;

            return updatedLimit;
        }

        return (parseInt(limitText) + valueToadd).toString();
    };

    private log = (...args: any[]) => {
        if (this.dev) console.log(args);
    };
    private convertPrice = (price: number) => {
        this.log('convertPrice price', price);

        if (this.customFormat) return this.customFormat(price);
        const value = Math.round(price).toLocaleString('en');

        return `$ ${value}`;
    };

    private setPrices(conventerNumberApps: any) {
        const price1Base = this.price1Base;
        const price2Base = this.price2Base;
        const price3Base = this.price3Base;
        const priceEl1 = this.price1Label;
        const priceEl2 = this.price2Label;
        const priceEl3 = this.price3Label;

        const price1 = this.convertPrice(conventerNumberApps + price1Base);
        const price2 = this.convertPrice(conventerNumberApps + price2Base);
        const price3 = this.convertPrice(conventerNumberApps + price3Base);
        this.log('setPrices conventerNumberApps', conventerNumberApps);
        this.log('setPrices prices', price1, price2, price3);
        if (priceEl1) priceEl1.textContent = price1;
        if (priceEl2) priceEl2.textContent = price2;
        if (priceEl3) priceEl3.textContent = price3;
    }

    private setLimits(limit: any) {
        const limit1Base = this.limit1BaseText;
        const limit2Base = this.limit2BaseText;
        const limit3Base = this.limit3BaseText;
        const limitEl1 = this.limit1Label;
        const limitEl2 = this.limit2Label;
        const limitEl3 = this.limit3Label;

        const limitLabel = this.limitLabel;

        const limit1 = this.convertLimit(limit1Base, limit);
        const limit2 = this.convertLimit(limit2Base, limit);
        const limit3 = this.convertLimit(limit3Base, limit);

        if (limitEl1) limitEl1.textContent = `${limit1} ${limitLabel}`;
        if (limitEl2) limitEl2.textContent = `${limit2} ${limitLabel}`;
        if (limitEl3) limitEl3.textContent = `${limit3} ${limitLabel}`;
    }

    public onChange(payload: { value: string } | { selected: number }) {
        this.log('onChange payload', payload);
        if ('selected' in payload) {
            this.selected = payload.selected;
        } else {
            this.selected =
                this.values.findIndex((v) => v === payload.value) || 0;
        }
        this.log('onChange this.selected', this.selected);

        this.calculate();
    }

    private calculate() {
        this.setPrices(this.prices[this.selected]);
        this.setLimits(this.limites[this.selected]);
    }

    get value() {
        return this.values[this.selected];
    }
}
